<div class="tsd_container">
  <form [formGroup]="myForm">
    <mat-card>
      <mat-card-content>
        <h4 class="__card_head">Client</h4>
        <mat-form-field>
          <mat-label>Client Code</mat-label>
          <input matInput placeholder="Client Code">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Client Name</mat-label>
          <input matInput placeholder="Client Name">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Email id</mat-label>
          <input matInput placeholder="Email id">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Contact No</mat-label>
          <input matInput placeholder="Contact No">
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-content>
        <h4 class="__card_head">Client GSA Details</h4>
        <table class="document_list" mat-table [dataSource]="gsaDataSource">
          <ng-container matColumnDef="{{col.id}}" *ngFor="let col of gsaCol;">
            <th mat-header-cell *matHeaderCellDef>
              <span *ngIf="col.id !== '$$edit'">
                {{col.name}}
              </span>
            </th>
            <td mat-cell *matCellDef="let element;let gsaColIndex = index;let last = last">
              <div *ngIf="((!element.isEdit || gsaIndex!=gsaColIndex+1) && last===false)"
                (dblclick)="element.isEdit=!editGsa(gsaColIndex+1)">
                <div class="btn-edit" *ngIf="col.id === '$$edit'; spanHeader">
                  <button class="__delete_btn" *ngIf="last===false" (click)="removeGsa(gsaColIndex)" mat-icon-button
                    color="primary">
                    <mat-icon class="__delete_icon">delete</mat-icon>
                  </button>
                </div>
                <span #spanHeader *ngIf="col.id !== 'role'">
                  {{element[col.id]}}
                </span>
                <span *ngIf="col.id === 'role'">
                  <mat-form-field class="example-chip-list">
                    <mat-chip-grid #chipList>
                      <mat-chip-row *ngFor="let _item of element.role;let roleIndex = index;" [removable]="true"
                        (removed)="removeRole(gsaColIndex,roleIndex)">
                        {{_item.roleName}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip-row>
                      <input placeholder="Role" #roleInput formControlName="roleControl" [matAutocomplete]="auto"
                        [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                    </mat-chip-grid>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addRole($event,gsaColIndex)">
                      <mat-option *ngFor="let _item of filteredRole | async" [value]="_item.roleName">
                        {{_item.roleName}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </span>
              </div>

              <div *ngIf="element.isEdit && gsaIndex===gsaColIndex+1" (clickOutside)="updateGsa(gsaColIndex)"
                [excludeBeforeClick]=true [exclude]="'.__editable'" class="__editable">
                <div class="btn-edit" *ngIf="col.id === '$$edit'; else dataField">
                  <button class="__delete_btn" (click)="removeGsa(gsaColIndex)" mat-icon-button color="primary"
                    focusable="false">
                    <mat-icon class="__delete_icon">delete</mat-icon>
                  </button>
                </div>
                <ng-template #dataField>
                  <mat-form-field *ngIf="col.id !== 'role'">
                    <input type="text" [formControl]="getControlGsa(gsaColIndex, col.id)" matInput
                      value="{{element[col]}}">
                    <mat-error *ngIf="getControlGsa(gsaColIndex, col.id).hasError('required')">
                      Field is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>

                  <div *ngIf="col.id === 'role'">
                    <mat-form-field class="example-chip-list">
                      <mat-chip-grid #chipList>
                        <mat-chip-row *ngFor="let _item of element.role;let roleIndex = index;" [removable]="true"
                          (removed)="removeRole(gsaColIndex,roleIndex)">
                          {{_item.roleName}}
                          <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip-row>
                        <input placeholder="Role" #roleInput formControlName="roleControl" [matAutocomplete]="auto"
                          [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                      </mat-chip-grid>
                      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addRole($event,gsaColIndex)">
                        <mat-option *ngFor="let _item of filteredRole | async" [value]="_item.roleName">
                          {{_item.roleName}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                </ng-template>
              </div>

              <div *ngIf="last===true">
                <mat-form-field *ngIf="col.id !== 'role' && col.id !== '$$edit'">
                  <input type="text" [formControl]="getControlGsa(gsaColIndex, col.id)" matInput>
                  <mat-error *ngIf="getControlGsa(gsaColIndex, col.id).hasError('required')">
                    Field is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
                <div *ngIf="col.id === 'role'">
                  <mat-form-field class="example-chip-list">
                    <mat-chip-grid #chipList>
                      <mat-chip-row *ngFor="let _item of element.role" [removable]="true"
                        (removed)="removeRole(gsaColIndex,_item)">
                        {{_item.roleName}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip-row>
                      <input placeholder="Role" #roleInput formControlName="roleControl" [matAutocomplete]="auto"
                        [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                    </mat-chip-grid>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addRole($event,gsaColIndex)">
                      <mat-option *ngFor="let _item of filteredRole | async" [value]="_item.roleName">
                        {{_item.roleName}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <button class="__delete_btn" *ngIf="col.id == '$$edit'" mat-icon-button color="primary"
                  (keyup.Tab)="newGsa($event,gsaColIndex)">
                  <mat-icon class="__delete_icon">delete</mat-icon>
                </button>
              </div>
            </td>

          </ng-container>
          <tr mat-header-row *matHeaderRowDef="gsaColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: gsaColumns;"></tr>
        </table>
      </mat-card-content>
    </mat-card>
    <mat-card>
      <mat-card-content>
        <h4 class="__card_head">Address Details</h4>
        <mat-form-field appearance="fill">
          <mat-label>Client Country</mat-label>
          <mat-select formControlName="clientCountryCtrl" placeholder="Client Country" required>
            <mat-option>
              <ngx-mat-select-search formControlName="clientCountryFilteringCtrl" [searching]="searching"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Client Country">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let item of filteredClientCountry | async" [value]="item">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Client Location in state/Province</mat-label>
          <mat-select formControlName="clientCountryCtrl" placeholder="Client Location in state/Provinc" required>
            <mat-option>
              <ngx-mat-select-search formControlName="clientCountryFilteringCtrl" [searching]="searching"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Client Location in state/Provinc">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let item of filteredClientCountry | async" [value]="item">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Client City</mat-label>
          <mat-select formControlName="clientCountryCtrl" placeholder="Client City" required>
            <mat-option>
              <ngx-mat-select-search formControlName="clientCountryFilteringCtrl" [searching]="searching"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Client City">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let item of filteredClientCountry | async" [value]="item">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>ZIP/PIN Code</mat-label>
          <input matInput placeholder="ZIP/PIN Code" required>
        </mat-form-field>
        <div class="text_area">
          <mat-form-field appearance="fill">
            <mat-label>Headquater/Corporate Office Address</mat-label>
            <textarea matInput resize="0" rows="5" placeholder="Headquater/Corporate Office Address"></textarea>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>


    <mat-card>
      <mat-card-content>
        <h4 class="__card_head">Tax Details</h4>
        <mat-form-field appearance="fill">
          <mat-label>Client PAN No./Income Tax id</mat-label>
          <input matInput placeholder="Client PAN No./Income Tax id" required>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>VAT/GST Type</mat-label>
          <input matInput placeholder="VAT/GST Type" required>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Client VAT ID/GST ID/Sales Tax ID</mat-label>
          <input matInput placeholder="Client VAT ID/GST ID/Sales Tax ID" required>
        </mat-form-field>


        <h6 class="__card_sub_head">Register Document Details</h6>
        <table class="document_list" mat-table [dataSource]="documentDataSource">
          <ng-container matColumnDef="{{col.id}}" *ngFor="let col of documentCol;let index = index">
            <th mat-header-cell *matHeaderCellDef>
              <span *ngIf="col.id !== '$$edit'">
                {{col.name}}
              </span>
            </th>
            <td mat-cell *matCellDef="let element;let documentColIndex = index;let last = last">
              <div *ngIf="((!element.isEdit || documentIndex!=documentColIndex+1) && last===false)"
                (dblclick)="element.isEdit=!editDocument(documentColIndex+1)">
                <div class="btn-edit" *ngIf="col.id === '$$edit'; spanHeader">
                  <button class="__delete_btn" (click)="removeDocument(documentColIndex)" mat-icon-button
                    color="primary">
                    <mat-icon class="__delete_icon">delete</mat-icon>
                  </button>
                </div>
                <span #spanHeader *ngIf="col.id !== 'uploadDocument'">
                  {{element[col.id]}}
                </span>
                <span class="__upload_csv" *ngIf="col.id === 'uploadDocument'">
                  <mat-icon class="__upload_icon">note_add</mat-icon>
                </span>
              </div>

              <div *ngIf="element.isEdit && documentIndex===documentColIndex+1"
                (clickOutside)="updateDocument(documentColIndex)" [excludeBeforeClick]=true [exclude]="'.__editable'"
                class="__editable">
                <div class="btn-edit" *ngIf="col.id === '$$edit'; else dataField">
                  <button class="__delete_btn" (click)="removeDocument(documentColIndex)" mat-icon-button
                    color="primary" focusable="false">
                    <mat-icon class="__delete_icon">delete</mat-icon>
                  </button>
                </div>
                <ng-template #dataField>
                  <mat-form-field *ngIf="col.id !== 'uploadDocument'">
                    <input type="text" [formControl]="getControlDocument(documentColIndex, col.id)" matInput
                      value="{{element[col]}}">
                    <mat-error *ngIf="getControlDocument(documentColIndex, col.id).hasError('required')">
                      Field is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                  <div class="__upload_csv" *ngIf="col.id === 'uploadDocument'">
                    <mat-icon class="__upload_icon">note_add</mat-icon>
                  </div>
                </ng-template>
              </div>
              <div *ngIf="last===true">
                <mat-form-field *ngIf="col.id !== 'uploadDocument' && col.id !== '$$edit'">
                  <input type="text" [formControl]="getControlDocument(documentColIndex, col.id)" matInput>
                </mat-form-field>
                <span class="__upload_csv" *ngIf="col.id === 'uploadDocument'">
                  <mat-icon class="__upload_icon">note_add</mat-icon>
                </span>
                <button class="__delete_btn" *ngIf="col.id == '$$edit'" mat-icon-button color="primary"
                  (keyup.Tab)="newDocument($event,documentColIndex)">
                  <mat-icon class="__delete_icon">delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="documentColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: documentColumns;"></tr>
        </table>
      </mat-card-content>
    </mat-card>
    <mat-card>
      <mat-card-content class="__active_tools">
        <h4 class="__card_head">Re-activation/De-activation Details</h4>
        <mat-slide-toggle>De-activate Client</mat-slide-toggle><br>

        <mat-slide-toggle>Re-activate Client</mat-slide-toggle><br>
        <mat-checkbox class="remember-margin">View Log</mat-checkbox>
        <mat-card-actions>
          <button mat-button color="secondary" (click)="onSave()">SAVE AS DRAFT</button>
          <button mat-button color="cancel" (click)="onCancel()">CANCEL</button>
          <button mat-button color="primary" (click)="onSave()">SAVE</button>
        </mat-card-actions>
      </mat-card-content>
    </mat-card>
  </form>
</div>